import PropTypes from 'prop-types';
import Currency from './Currency';
import './SalePrice.scss';
import Tooltip from '@mui/material/Tooltip';
import {isNZLocale} from 'lib/PropertyUtils';

const TOOLTIP_SLOT_PROPS = {
    tooltip: {
        sx: {
            maxWidth: 240,
            lineHeight: 1.5,
            fontSize: '11px',
            padding: 1.5,
        },
    },
};

function SalePriceTooltip({ title, arrow, children }) {
    return (
        <Tooltip title={title} slotProps={TOOLTIP_SLOT_PROPS} arrow={arrow}>
            {children}
        </Tooltip>
    );
}

SalePriceTooltip.propTypes = {
    title: PropTypes.node.isRequired,
    arrow: PropTypes.bool,
    children: PropTypes.node.isRequired,
};

const RECENT_SOLD = isNZLocale()
    ? 'Recent Sale: A recently captured sale which is yet to be verified by the Valuer Generals.'
    : <span>Recent Sale – Pending Settlement Advice<br />This property has a sale provided that has yet to be verified as settled by a government authority.</span>;

const PRICE_WITHHELD_TITLE = '\'Un\' represents a sale submitted as \'undisclosed\' and is only exposed in RP Data to Real Estate Agents and Valuers. These results will not be visible in consumer platforms.';

SalePrice.propTypes = {
  isAgentsAdvice: PropTypes.bool,
  isPriceWithheld: PropTypes.bool,
  salePrice: PropTypes.number,
};

export default function SalePrice({ isAgentsAdvice, isPriceWithheld, salePrice, style, children }) {
  return (
    <div className="SalePrice">
      <SalePriceTooltip title={RECENT_SOLD} arrow>
        <sup hidden={!isAgentsAdvice} className="rs">RS</sup>
      </SalePriceTooltip>
      <span className={`sale-price ${isAgentsAdvice ? 'hide' : ''}`} style={style}>
        <Currency currency={salePrice} />
        {children}
      </span>
      <SalePriceTooltip title={PRICE_WITHHELD_TITLE} arrow>
        <sup hidden={!isPriceWithheld} className="un">UN</sup>
      </SalePriceTooltip>
    </div>
  );
}
